import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-intersect",
  templateUrl: "./med-icon-intersect.component.html",
})
export class MedIconIntersectComponent extends SvgMixinComponent {}
